import TileAnimation from "./TileAnimation.js";

export default class Torch extends TileAnimation {
	constructor(sp, cell, tile, level) {
		super(sp, cell, tile, level, Torch.ANIMATIONS)
		this.clas = "torch";
		//this.target.css("top",-8)
	}
}

Torch.RADIUS = 2;
Torch.ANIMATIONS = [
	{
		id: "unlit",
		sheet: "torch",
		flip: false,
		frames: [
			{
				row: 0,
				col: 4,
				time: -1
			}
		]
	},
	{
		id: "lit",
		sheet: "torch",
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: 80
			},
			{
				row: 0,
				col: 1,
				time: 100
			},
			{
				row: 0,
				col: 2,
				time: 85
			},
			{
				row: 0,
				col: 3,
				time: 95
			},
		]
	},
]